import request from '@/utils/request'

let CompanyApi = {

  /*公司简介列表*/
  list(data) {
    return request._post('/shop/plus.company.Index/index', data);
},
/*添加公司简介*/
add(data) {
    return request._post('/shop/plus.company.Index/add', data);
},
/*修改公司简介*/
edit(data) {
    return request._post('/shop/plus.company.Index/edit', data);
},
/*删除公司简介*/
del(data) {
    return request._post('/shop/plus.company.Index/del', data);
},
/*公司简介详情*/
detail(data) {
  return request._post('/shop/plus.company.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.company.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.company.Setting/getSetting', data, errorback);
    },
}
export default CompanyApi;



// WEBPACK FOOTER //
// ./src/api/company.js